import { useState } from 'react';
import { TextField, Button, Stack, Box, Alert } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import AuthShell from '../components/AuthShell';
import api from '../utils/axios';
import { getErrorMessage, buildErrorSnackbarOptions } from '../utils/errorUtils';

const MIN = 10;

export default function Activate() {
    const [params] = useSearchParams();
    const token = params.get('token') || '';
    const navigate = useNavigate();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [submitting, setSubmitting] = useState(false);

    if (!token) {
        return (
            <AuthShell title="Lien d'activation invalide">
                <Alert severity="error">Ce lien d'activation est incomplet ou expiré. Contactez votre représentant Amabec pour en recevoir un nouveau.</Alert>
            </AuthShell>
        );
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (password.length < MIN) {
            enqueueSnackbar(`Le mot de passe doit contenir au moins ${MIN} caractères`, { variant: 'error' });
            return;
        }
        if (password !== confirm) {
            enqueueSnackbar('La confirmation ne correspond pas', { variant: 'error' });
            return;
        }
        setSubmitting(true);
        try {
            await api.post('/b2b/auth/activate', { token, password });
            enqueueSnackbar('Compte activé. Connectez-vous avec votre nouveau mot de passe.', { variant: 'success' });
            navigate('/login', { replace: true });
        } catch (err) {
            enqueueSnackbar(getErrorMessage(err, 'Activation impossible'), buildErrorSnackbarOptions(err, closeSnackbar));
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <AuthShell title="Activez votre compte" subtitle={`Choisissez un mot de passe de ${MIN} caractères minimum.`}>
            <Box component="form" onSubmit={handleSubmit} noValidate>
                <Stack spacing={2}>
                    <TextField
                        label="Nouveau mot de passe"
                        type="password"
                        autoComplete="new-password"
                        autoFocus
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        helperText={`${MIN} caractères minimum`}
                    />
                    <TextField
                        label="Confirmer le mot de passe"
                        type="password"
                        autoComplete="new-password"
                        value={confirm}
                        onChange={(e) => setConfirm(e.target.value)}
                        required
                    />
                    <Button type="submit" variant="contained" size="large" disabled={submitting}>
                        {submitting ? 'Activation…' : 'Activer mon compte'}
                    </Button>
                </Stack>
            </Box>
        </AuthShell>
    );
}
